<ui-card class="flex-1" [noBorder]="true">
  <ng-container content>
    <div class="flex gap-3 justify-between">
      @for (item of data()?.items; track $index; let index = $index) {

      <div class="type-card">
        <div class="flex gap-3 items-center">
          <span class="type-card-title">{{ item.value | thousandsDelimiter }}</span>
          <span class="type-card-subtitle">
            <span
              class="type-card-subtitle-top"
              [ngClass]="index === 0 ? 'type-one' : index === 1 ? 'type-two' : 'type-three'"
            >
              {{ item.title || 'отсутствует' }}
            </span>
            <span class="type-card-subtitle-bottom">{{ item.percentage + '%' }}</span>
          </span>
        </div>
        <!-- <div class="flex flex-wrap gap-3 mt-2">
            <div class="flex flex-row gap-2">
              <ui-icon
                [name]="item.percentage > 0 ? 'rise': item.percentage < 0 ? 'fall': 'minus'"
                [color]="item.percentage > 0 ? '#4cb050': item.percentage < 0 ? '#f13d3d': '#868686'"
                size="20px"
              ></ui-icon>
              <div>{{ item.percentage | number:'1.2-2' }}</div>
            </div>
            <div>в этом году</div>
          </div> -->
      </div>

      }
    </div>

    <div class="type-card-progress">
      @for (item of data()?.items; track $index; let index = $index) {
      <div
        [ngClass]="index === 0 ? 'type-one' : index === 1 ? 'type-two' : 'type-three'"
        [ngStyle]="{ width: item.percentage + '%' }"
      ></div>
      }
    </div>
  </ng-container>
</ui-card>
